import React, { useContext, useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import Image from '../common/image';
import Icon4 from "../../assest/images/Icon4.png";
import Icon3 from "../../assest/images/Icon3.png";
import { ToastContainer, toast } from 'react-toastify';
import config from "../../envconfig";
import CustomDropdown from '../common/CustomDropdown';
import axios from "axios"
import { UserContext } from '../common/UserContext';


const CMList = () => {
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext); const [userData, setUserdata] = useState([]);
    const [message, setMessage] = useState('');
    const [firstFilter, setFirstFilter] = useState('');
    const [firstFilterSearch, setFirstFilterSearch] = useState('');
    const [secondFilter, setSecondFilter] = useState('');
    const [secondFilterSearch, setSecondFilterSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [statusFilter, setStatusFilter] = useState('');

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [companyIdToSuspend, setCompanyIdToSuspend] = useState(null);
    const [remark, setRemark] = useState('');
    const [remarkError, setRemarkError] = useState(false);
const toastRef = useRef(null);
const showToast = (type, message, options = {}) => {
  if (toastRef.current && toast.isActive(toastRef.current)) {
    toast.update(toastRef.current, {
      render: message,
      type,
      autoClose: 3000,
      ...options,
    });
  } else {
    toastRef.current = toast[type](message, {
      autoClose: 3000,
      ...options,
    });
  }
};

    // THIS API IS USED TO PRINT THE LOG IN DRIVE D IN LOG FOLDER  
    const logAction = async (action, isError = false) => {
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "Company Master List:", action, userCode: UM_UserCode, isError }),
            });

            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    // Audit Trail
    const audittransection = async (data) => {
        const formData = {
            AUTRN_ID: data.AUTRN_ID,
            AUTRN_OldValue: data.AUTRN_OldValue ?? null,
            AUTRN_NewValue: data.AUTRN_NewValue,
            AUTRN_ParamererName: data.AUTRN_ParamererName
        };
        try {
            const response = await axios.post(`${config.API_URL}/api/audittransaction`, formData);
        } catch (error) {
            if (error.response) {
                console.error('Server responded with an error:', error.response.data);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Error setting up the request:', error.message);
            }
        }
    }


    const audittrailpost = async (details) => {
        const getCurrentTimestamp = () => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // months are zero-indexed
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        const currentTimestamp = getCurrentTimestamp();
        const data = {
            AUTR_ScreenName: "Company Master List",
            AUTR_OldValue: details?.AUTR_OldValue ?? null,
            AUTR_NewValue: details?.AUTR_NewValue ?? null,
            AUTR_Message: details?.AUTR_Message ?? '-',
            AUTR_UserID: UM_UserId || null, // Ensure valid values
            AUTR_UserName: UM_UserCode || null,
            AUTR_TimeStamp: currentTimestamp,
            AUTR_AuditType: details?.AUTR_AuditType ?? 'Default',
            AUTR_SCPID: selectedScpId || null,
            AUTR_CompanyGrpId: UM_CompanyGrpID || null,
            AUTR_CompanyID: UM_CompanyID || null,
            AUTR_CreatedBy: UM_UserId || null,
            AUTR_CreatedDateTime: currentTimestamp
        };

        console.log('Sending data:', data);

        try {
            const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
            console.log('Success:', response.data);
            return response.data;
        } catch (error) {
            if (error.response) {
                console.error('Server responded with an error:', error.response.data);
            } else if (error.request) {
                console.error('No response received from server:', error.request);
            } else {
                console.error('Error setting up the request:', error.message);
            }
        }
    };


    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);

        sessionStorage.setItem('selectedScpId', selectedScpId);

    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);
    const [firstFilterOptions, setFirstFilterOptions] = useState([
        { value: 'CM_CompanyName', label: 'Company Name', disabled: false },
        { value: 'CM_CompanyCode', label: 'Company Code', disabled: false },
        { value: 'CGM_CompanyGroupName', label: 'Company Group Name', disabled: false },
    ]);

    const [secondFilterOptions, setSecondFilterOptions] = useState([
        { value: 'CM_CompanyName', label: 'Company  Name', disabled: false },
        { value: 'CM_CompanyCode', label: 'Company  Code', disabled: false },
        { value: 'CGM_CompanyGroupName', label: 'Company Group Name', disabled: false },
    ]);

    useEffect(() => {
        setCurrentPage(1);
    }, [firstFilterSearch, secondFilterSearch, statusFilter]);

    useEffect(() => {
        const getUserdata = async () => {
            try {
                const reqData = await fetch(`${config.API_URL}/CM`, {
                    method: 'GET',
                });

                if (reqData.ok) {
                    const resData = await reqData.json();
                    console.log('List of companies', resData);
                    setUserdata(resData);
                } else {
                    console.error('Error fetching the company list');
                    logAction('getUserdata():Error fetching the company list', true)
                }
            } catch (error) {
                console.log('Failed to fetch data:', error);
                setMessage('Please check Data');
                logAction('getUserdata():Failed to check data', true)
            }
        };
        getUserdata();
    }, []);

    const handleConfirmStatusChange = (CM_ID) => {
        setCompanyIdToSuspend(CM_ID);
        setShowConfirmation(true);
    };
    const handleRemarkChange = (e) => {
        const value = e.target.value;
        setRemark(value);
        if (remarkError && value.trim() !== '') {
            setRemarkError(false); // Clear the error once the user starts typing
        }
    };

    const handleConfirmAction = async () => {
        if (companyIdToSuspend) {
            if (remark.trim() === '') {
                setRemarkError(true);
                return; // Do not proceed if remark is empty
            }
            try {
                const CompanyName = `${companyIdToSuspend.CM_CompanyName}`
                const updateStatusData = await fetch(`${config.API_URL}/CM/Suspend/${companyIdToSuspend.CM_ID}`, {
                    method: 'PUT',
                    headers: { 'content-type': 'application/json' },
                    body: JSON.stringify({
                        CM_SuspendRemark: remark,
                        CM_CompanyName: CompanyName

                    }),
                });

                if (updateStatusData.ok) {
                    setUserdata(prevUserData => {
                        return prevUserData.map(item => {
                            if (item.CM_ID === companyIdToSuspend.CM_ID) {
                                return { ...item, CM_Status: 3 };
                            }
                            return item;
                        });
                    });

                    showToast('success',`Company : ${companyIdToSuspend.CM_CompanyName} suspended successfully.`);
                    logAction(`handleConfirmAction(): Company : ${companyIdToSuspend.CM_CompanyName} suspended successfully`);

                    setRemark('');

                    const details = {
                        AUTR_Message: `${companyIdToSuspend.CM_CompanyName} Suspend`,
                        AUTR_AuditType: "Suspend",
                        AUTR_OldValue: (companyIdToSuspend.CM_Status === 1) ? "Active" :
                            (companyIdToSuspend.CM_Status === 2) ? "Inactive" : "Unknown",
                        AUTR_NewValue: "Suspend"
                    };

                    let id = await audittrailpost(details);
                    const details1 = {
                        AUTRN_ParamererName: "Status",
                        AUTRN_ID: id,
                        AUTRN_NewValue: "Suspend",
                        AUTRN_OldValue: (companyIdToSuspend.CM_Status === 1) ? "Active" :
                            (companyIdToSuspend.CM_Status === 2) ? "Inactive" : "Unknown",
                    };

                    audittransection(details1);
                    // } else {
                    //     const errorMessage = await updateStatusData.text();
                    //     console.error('Error updating status:', errorMessage);
                    //     if (updateStatusData.status === 400) {
                    //         showToast('error',`You cannot suspend the Company : ${companyIdToSuspend.CM_CompanyName} because a reference exists in the Company IT Policy Master.`);
                    //         setRemark('');
                    //     } else {
                    //         showToast('error',`Company : ${companyIdToSuspend.CM_CompanyName} could not be suspended successfully`);
                    //         setRemark('');
                    //     }
                    // }
                } else {
                    const errorMessage = await updateStatusData.text();
                    console.error('Error updating status:', errorMessage);

                    if (updateStatusData.status === 400) {

                        if (errorMessage.includes("Company Configuration")) {
                            showToast('error',
                                `You cannot suspend the Company : ${companyIdToSuspend.CM_CompanyName} because a reference exists in the Company Configuration.`
                            );
                        }
                        else if (errorMessage.includes("Company IT Policy")) {
                            showToast('error',
                                `You cannot suspend the Company : ${companyIdToSuspend.CM_CompanyName} because a reference exists in the Company IT Policy Master.`
                            );
                        }
                        else {
                            showToast('error',
                                `You cannot suspend the Company : ${companyIdToSuspend.CM_CompanyName} due to existing references.`
                            );
                        }

                        setRemark('');
                    }
                    else {
                        showToast('error',
                            `Company : ${companyIdToSuspend.CM_CompanyName} could not be suspended successfully`
                        );
                        setRemark('');
                    }
                }

            } catch (err) {
                console.log('Network error:', err);
                showToast('error',`Company : ${companyIdToSuspend.CM_CompanyName} could not be suspended successfully`);
                setRemark('');
            }
        }
        setRemark('');
        setShowConfirmation(false);
    };

    const handleCancelAction = () => {
        setCompanyIdToSuspend(null);
        setShowConfirmation(false);
        setRemark(''); // Reset the remark on cancellation
        setRemarkError(false);
    };

    const handleFirstFilterChange = (event) => {
        const value = event.target.value;
        setFirstFilter(value);
        setFirstFilterSearch('');

        const updatedSecondOptions = secondFilterOptions.map(option => ({
            ...option,
            disabled: option.value === value
        }));
        setSecondFilterOptions(updatedSecondOptions);
    };

    const handleSecondFilterChange = (event) => {
        const value = event.target.value;
        setSecondFilter(value);
        setSecondFilterSearch('');

        const updatedFirstOptions = firstFilterOptions.map(option => ({
            ...option,
            disabled: option.value === value
        }));
        setFirstFilterOptions(updatedFirstOptions);
    };

    const handleStatusFilterChange = (event) => {
        const value = event.target.value;
        logAction("handleStatusFilterChange(): Status is changed in the dropdown");
        setStatusFilter(value);
        logAction("handleStatusFilterChange(): Data filtered according to the selected status");
    };

    const getStatusLabel = (status) => {
        switch (status) {
            case 1:
                return 'Active';
            case 2:
                return 'Inactive';
            case 3:
                return 'Suspend';
            default:
                return '';
        }
    };

    const filteredListData = userData.filter(item => {
        const firstFilterValue = item[firstFilter];
        const secondFilterValue = item[secondFilter];
        const statusValue =
            getStatusLabel(item.CM_Status);
        const containsActive = /act(ive)?/i.test(firstFilterSearch);
        const containsInactive = /inact(ive)?/i.test(firstFilterSearch);

        const matchesFirstFilter =
            (!firstFilter || !firstFilterSearch) ||
            (firstFilter === 'CM_Status' &&
                (
                    (containsActive && firstFilterValue === 1) ||
                    (containsInactive && firstFilterValue === 2)
                )
            ) ||
            (firstFilter !== 'CM_Status' && String(firstFilterValue).toLowerCase().includes(firstFilterSearch.toLowerCase()));
        const containsActive2 = /act(ive)?/i.test(secondFilterSearch);
        const containsInactive2 = /inact(ive)?/i.test(secondFilterSearch);

        const matchesSecondFilter =
            (!secondFilter || !secondFilterSearch) ||
            (secondFilter === 'CM_Status' &&
                (
                    (containsActive2 && secondFilterValue === 1) ||
                    (containsInactive2 && secondFilterValue === 2)
                )
            ) ||
            (secondFilter !== 'CM_Status' && String(secondFilterValue).toLowerCase().includes(secondFilterSearch.toLowerCase()));
        const matchesStatusFilter = !statusFilter || statusValue === statusFilter;
        return matchesFirstFilter && matchesSecondFilter && matchesStatusFilter;
    });


    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredListData.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };

    return (
        <React.Fragment>
            <ToastContainer style={{
                marginTop: '73px',
                fontSize: '14px',
                width: '40%',
            }} />
            <div className='main_container'>
                <h4 className='formHeading'>
                    Company Master
                </h4>
                <p>{message}</p>

                <div className="filter-container">
                    <div className='select-container_list'>
                        <CustomDropdown
                            options={firstFilterOptions}
                            value={firstFilter}
                            onChange={handleFirstFilterChange}
                            name="firstFilter"
                            placeholder="--Select--"
                            idKey="value"
                            displayKey="label"
                            onMenuOpen={() => handleSelectOpen('firstFilter')}
                            onMenuClose={handleSelectClose}
                        />

                    </div>
                    <input type="text"
                        className='search-input'
                        value={firstFilterSearch} onChange={(e) => setFirstFilterSearch(e.target.value)} placeholder={`Search`} />
                    <div className='select-container_list'>
                        <CustomDropdown
                            options={secondFilterOptions}
                            value={secondFilter}
                            onChange={handleSecondFilterChange}
                            name="secondFilter"
                            placeholder="--Select--"
                            idKey="value"
                            displayKey="label"
                            onMenuOpen={() => handleSelectOpen('secondFilter')}
                            onMenuClose={handleSelectClose}
                        />
                    </div>
                    <input type="text"
                        className='search-input'
                        value={secondFilterSearch} onChange={(e) => setSecondFilterSearch(e.target.value)} placeholder='Search' />

                    <div className='select-container_list'>
                        <CustomDropdown
                            options={[
                                { value: 'Active', label: 'Active' },
                                { value: 'Inactive', label: 'Inactive' },
                                { value: 'Suspend', label: 'Suspend' }
                            ]}
                            value={statusFilter}
                            onChange={handleStatusFilterChange}
                            name="statusFilter"
                            placeholder="--Select Status--"
                            idKey="value"
                            displayKey="label"
                            onMenuOpen={() => handleSelectOpen('statusFilter')}
                            onMenuClose={handleSelectClose}
                        />
                    </div>
                </div>


                <div className="ptable-wrapper">
                    <table className="ptableClass">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Company Name</th>
                                <th>Company Code</th>
                                <th>Company Group Name</th>
                                <th>Company URL</th>
                                <th>Company Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        {filteredListData.length === 0 ? (
                            <tbody >
                                <tr>
                                    <td colSpan="9">No Records Found</td> {/* Set colSpan to match the number of columns */}
                                </tr>
                            </tbody>
                        ) : (
                            <tbody>
                                {currentItems.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                        <td>{item.CM_CompanyName}</td>
                                        <td>{item.CM_CompanyCode}</td>
                                        <td>{item.CGM_CompanyGroupName}</td>
                                        <td
                                            style={{
                                                userSelect: "text",
                                            }}
                                        >
                                            <span>
                                                {config.REACT_APP_DOMAIN + item.CM_CompanyUrl}
                                            </span>
                                        </td>



                                        <td>
                                            {item.CM_Status === 1 && 'Active'}
                                            {item.CM_Status === 2 && 'Inactive'}
                                            {item.CM_Status === 3 && 'Suspend'}
                                        </td>
                                        <td>
                                            {item.CM_Status !== 3 ? (
                                                <>
                                                    <Link to={`/cmedit/${item.CM_ID}`} type='button' className='' title='Edit'>
                                                        <Image src={Icon3} alt="pencil" className="editicon" />
                                                    </Link>
                                                    <img
                                                        src={Icon4}
                                                        alt="suspendremovebg"
                                                        className="suspendicon"
                                                        style={{ cursor: 'pointer', marginRight: '0px' }}
                                                        onClick={() => handleConfirmStatusChange(item)}
                                                        title='Suspend'
                                                    />
                                                </>
                                            ) : (
                                                <span style={{ color: '#465a64' }}>-</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>
                <ul className="pagination">
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(1)}>First</button>
                    </li>
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
                    </li>
                    {Array.from({ length: Math.ceil(filteredListData.length / itemsPerPage) }, (_, index) => (
                        <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
                            <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
                        </li>
                    ))}
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
                    </li>
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(Math.ceil(filteredListData.length / itemsPerPage))}>Last</button>
                    </li>
                </ul>

            </div>
            <Link to={`/dashboard/companymaster`} type='button' className='back_btn'>
                BACK
            </Link>
            {showConfirmation && (
                <div className="popup_overlay">
                    <div className="resetpopup">
                        <h1>:: User Confirmation ::</h1>
                        <h4>Are you sure you want to suspend this Company : {companyIdToSuspend?.CM_CompanyName} ?</h4>
                        <div className='remark_container'>
                            <span className='me-3 remark_label'>Remark:  {remarkError && <span style={{ color: 'red' }}>*{remarkError}</span>}</span>
                            <textarea
                                type='text'
                                className='remark_text'
                                value={remark}
                                onChange={handleRemarkChange}
                                placeholder="Enter suspend remark"
                                style={{
                                    border: '1px solid #ced4da',
                                    padding: '10px',
                                    fontSize: '16px',
                                    resize: 'none',  // Keep this if you want to prevent resizing
                                    overflow: 'auto',  // Enable scrollbars when content overflows
                                    transition: 'height 0.3s',
                                    borderRadius: "5px",
                                    outline: "none"

                                }}
                            />
                        </div>

                        <div className="popup_btn_container">
                            <button className="yes_btn " onClick={handleConfirmAction}>Yes</button>
                            <button className="no_btn " onClick={handleCancelAction}>No</button>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default CMList;

